import CountUp from 'react-countup';
import VideoBrowser from '../../reusable-components/video-browser/video-browser';
import './round-over-screen.scss';

interface  RoundOverScreenProps {
  videoHistory: VideoInfo[][];
  roundScores: RoundScores;
  roundNumber: number;
}

/**
 * The screen displayed at the end of a game round, showing a "correct" message, round scores, and video history.
 * @param {VideoInfo[][]} videoHistory - A nested array containing video information for each round played.
 * @param {RoundScores} roundScores - Scores for the current round's certainty and independence.
 * @param {number} roundNumber - The number of the current round.
 * */
const RoundOverScreen: React.FC<RoundOverScreenProps> = ({videoHistory, roundScores, roundNumber}) => {

  return (
    <div className="round-over-screen">
      <div className={`correct ${roundScores.independence + roundScores.certainty === 200 && 'perfect'}`}>
        {roundScores.independence + roundScores.certainty === 200 ? `PERFECT!!!` : `CORRECT!`}
      </div>
      <div className="round-scores">
        <div className="advanced-score">{`Accuracy: `}
          <CountUp 
            end={roundScores.certainty}
            duration={3}
            useEasing={false}/> 
        </div>
        <div className="advanced-score">{`Independence: `}
          <CountUp 
            end={roundScores.independence}
            duration={3}
            useEasing={false}/> 
        </div>
        <div className="total-score">{`Total Round Score: `}
          <CountUp 
            end={roundScores.independence + roundScores.certainty}
            duration={3}
            useEasing={false}/> 
        </div>
      </div>
      <div className="video-history">
        <VideoBrowser
          videoHistory={videoHistory}
          roundNumber={roundNumber}/>
      </div>
    </div>
  )
}

export default RoundOverScreen;